<template>
  <div class="order-meta-items">
    <v-row dense no-gutters v-if="familyDiscountLineItem">
      <v-col class="text-sm-right mr-2">
        <h3 class="font-weight-light">Family Discount: </h3></v-col
      >
      <v-col class="text-right" cols="6" sm="2">
        <h3 class="font-weight-light">{{
          formatUSD(-familyDiscountLineItem.total_price)
        }}</h3></v-col
      >
    </v-row>
    <v-row dense no-gutters>
      <v-col class="text-sm-right mr-2">
        <h3 class="font-weight-light">Sales Tax: </h3></v-col
      >
      <v-col class="text-right" cols="6" sm="2">
        <h3 class="font-weight-light">{{
          order.tax ? order.tax_formatted : '-'
        }}</h3></v-col
      >
    </v-row>
    <v-row dense no-gutters v-for="fee of order.fees" :key="fee.id">
      <v-col class="text-sm-right mr-2">
        <h3 class="font-weight-light">{{ fee.item_name }}: </h3></v-col
      >
      <v-col class="text-right" cols="6" sm="2">
        <h3 class="font-weight-light">{{ fee.item_price_formatted }}</h3></v-col
      >
    </v-row>
    <v-row dense no-gutters v-if="order.service_fee">
      <v-col class="text-sm-right mr-2">
        <h3 class="font-weight-light">Service Fee: </h3></v-col
      >
      <v-col class="text-right" cols="6" sm="2">
        <h3 class="font-weight-light">{{
          order.service_fee_formatted
        }}</h3></v-col
      >
    </v-row>
    <v-row dense no-gutters>
      <v-col class="text-sm-right mr-2">
        <h3 class="font-weight-light">Tip: </h3></v-col
      >
      <v-col class="text-right" cols="6" sm="2">
        <h3 class="font-weight-light">{{
          order.tip ? order.tip_formatted : '-'
        }}</h3></v-col
      >
    </v-row>
  </div>
</template>

<script>
import OrderModel from '@/models/OrderModel'
import formatUSD from '@/utils/formatUSD'
export default {
  name: 'OrderMetaItems',
  props: {
    order: {
      type: OrderModel,
      default: () => OrderModel,
    },
  },
  methods: { formatUSD },
  computed: {
    familyDiscountLineItem() {
      return this.order.line_items.find(
        (li) => li.item_name === 'Family Discount'
      )
    }, // familyDiscountLineItem
  },
  data() {
    return {}
  },
}
</script>
